import {
  MappingIdentifierPart,
  MappingIdentifierType,
} from 'src/containers/ProjectDiagram/types/data';
import { isMapping } from 'src/containers/ProjectDiagram/utils/data';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

type OldMappingIdentifier = MappingIdentifierPart[];
/**
 * * on {@link Mapping} update `primaryIdentifier`, `sourcePrimaryIdentifier`, and
 * `targetPrimaryIdentifier` fields from @type {(string | null)} to {@link OldMappingIdentifier}
 */
// prevState must be typed as `any` since it's an older version of the Redux State

export const v6 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v6Projects(prevState.projects);
  }

  return nextState;
};

const v6Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    if (!project.diagram) {
      projectsById[projectId] = project;
      return;
    }

    const updatedLinkDataArray = project.diagram.model.linkDataArray.map(
      (linkData) => {
        if (isMapping(linkData)) {
          const {
            primaryIdentifier,
            sourcePrimaryIdentifier,
            targetPrimaryIdentifier,
          } = linkData as any;
          const newPrimaryIdentifier: OldMappingIdentifier = primaryIdentifier
            ? [{ type: MappingIdentifierType.FIELD, value: primaryIdentifier }]
            : [];
          const newSourcePrimaryIdentifier: OldMappingIdentifier =
            sourcePrimaryIdentifier
              ? [
                  {
                    type: MappingIdentifierType.FIELD,
                    value: sourcePrimaryIdentifier,
                  },
                ]
              : [];
          const newTargetPrimaryIdentifier: OldMappingIdentifier =
            targetPrimaryIdentifier
              ? [
                  {
                    type: MappingIdentifierType.FIELD,
                    value: targetPrimaryIdentifier,
                  },
                ]
              : [];
          return {
            ...linkData,
            primaryIdentifier: newPrimaryIdentifier,
            sourcePrimaryIdentifier: newSourcePrimaryIdentifier,
            targetPrimaryIdentifier: newTargetPrimaryIdentifier,
          };
        }
        return linkData;
      }
    );

    projectsById[projectId] = {
      ...project,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          // @ts-ignore - old linkDataArray type
          linkDataArray: updatedLinkDataArray,
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
